import featureToggleService, { FeatureToggle } from "./featureToggleService";

class CssFeatureToggleService {
    init() {
        this.updateCssClasses();
    }

    private updateCssClasses() {
        const isWEM1418Enabled = featureToggleService.isEnabled(
            FeatureToggle.WEM_1418_IDUI_SPARK_V4_FLARE
        );
        const isWEM437Enabled = featureToggleService.isEnabled(
            FeatureToggle.WEM_437_SCREEN_MONITORING
        );

        document.body.classList.toggle(
            "ft-wem-1418-idui-spark-v4-flare",
            isWEM1418Enabled
        );

        document.body.classList.toggle(
            "wem-437-screen-monitoring",
            isWEM437Enabled
        );
    }
}

export default new CssFeatureToggleService();
